export default {
	name: "review-order-exTank",
	props:{
		orderExTankId: {
			default: null
		},
		orderId:{
			default: null
		}
	},
	data() {
		return {
			order: {},
			orderGrandTotal: 0,
			billingAddress:null,
			shippingAddress: null,
			reasonsForDeliveryFailure: [],
			deliveryProcessFeatureFlags: {},
			totalForOrder: 0,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			dateOfCompletion:{
				value: new Date(),
				errorMessage: null,
				hasError: false,
				initialiseDate: true
			},
			reviewOrder:{
				acceptOrder:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				sbo:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				releaseSlip:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				releaseLetter:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				comment:{
					value: null,
					hasError: false,
					errorMessage: null
				}
			},
			orderItemsHasError: false,
			orderItemsErrorMessage: null,
			orderItemsHeadings: [
				{
					text: "Product",
					field: "product"
				},
				{
					text: "Price",
					field: "priceAsString"
				},
				{
					text: "Quantity/Litres",
					field: "quantity"
				},
				{
					text: "Amount Dispensed",
					field: "quantityDispensed"
				},
				{
					text: "Total",
					field: "totalAsString"
				},
				// {
				// 	text: "Total Price Dispensed",
				// 	field: "totalDispensedAsString"
				// }
			],
			trackingHistoryModal:{
				showModal: false,
				isSaving: false,
				modalId: "trackingHistoryModal",
				heading: "Tracking History",
				orderId: null
			},
			orderItemsDispensed: [],
			cancelOrderModalId: "cancelOrderModal",
			markAsOnDeliveryModalId: "markAsOnDeliveryModal",
			cancelOrderScheduledForDeliveryModalId: "cancelOrderScheduledForDeliveryModal",
			completeOrderConfirmationModalId: "completeOrderConfirmationModal",
			orderStatus: {},
			actions: [],
			actionKeys:{
				edit: "edit",
				delete: "delete"
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			loadingBillingAddress: false,
			selectedHeartbeatStatusCodeId: null,
			successModal:{
				modalHeading: "Success",
				modalMessage: null,
				elementId: "reviewOrderSuccessModal",
				showModal: false
			}
		};
	},
	methods: {
		getExTankOrder(){
			this.loading = true;
			exTankService.getExTankOrder(this.orderExTankId).then(
				successResponse =>{
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.order = successResponse.data.result;
						this.reviewOrder.acceptOrder.value = this.order.orderAccepted;
						this.reviewOrder.sbo.value = this.order.sbo;
						this.reviewOrder.comment.value = this.order.acceptedReason
						this.order = dataTableHelper.castObjectValues(this.order);
						//this.order.orderItems = dataTableHelper.castObjectValues(this.order.orderItems);
						// for(let i = 0; i < this.order.orderItems.length; i++){
						// 	this.order.orderItems[i].priceAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].unitPrice);
						// 	this.order.orderItems[i].totalAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].totalAmount);
						// 	//this.order.orderItems[i].totalDispensedAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].totalPriceDispensed);
						// 	//this.order.total += this.order.orderItems[i].total;
						// }
						this.order.totalAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.order.totalAmount);
						this.orderGrandTotal = this.order.totalAmount;
						if(this.order.discountedAmount !== null && this.order.discountedAmount > 0) {
							this.orderGrandTotal = this.order.totalAmount - this.order.discountedAmount;
						}
						this.orderGrandTotal = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderGrandTotal);
						
						console.log("order", this.order);
						this.setBreadcrumbs();
						this.getCustomerBillingAddress();
					}
					this.loading = false;
					// setTimeout(function (){
					// 	var btnViewOrderCancel = document.getElementById("btnViewOrderCancel");
					// 	var btnViewOrderDownload = document.getElementById("btnViewOrderDownload");
					// 	var btnViewOrderViewTrackingHistory = document.getElementById("btnViewOrderDownload");
					// 	var viewOrderActions = document.getElementById("viewOrderActions");
					// 	if(btnViewOrderCancel.classList.contains("hide-element") &&
					// 		btnViewOrderDownload.classList.contains("hide-element") &&
					// 		btnViewOrderViewTrackingHistory.classList.contains("hide-element")){
					// 		viewOrderActions.classList.add("hide-element");
					// 	}
					// }, 100)

				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerBillingAddress(){
			this.loadingBillingAddress = true;
			customerService.getCompanyAddress(this.order.billingAddressId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.billingAddress = successResponse.data.result;
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onReleaseLetterAttach(event){
			this.reviewOrder.releaseLetter.value = event.target.files[0];
			console.log("release letter", this.reviewOrder.releaseLetter.value);
		},
		onReleaseSlipAttach(event){
			this.reviewOrder.releaseSlip.value = event.target.files[0];
		},
		acceptOrRejectExTankOrder(){
			this.loading = true;
			let request = {
				orderId: this.order.orderId,
				orderExTankId: this.orderExTankId,
				orderAccepted: this.reviewOrder.acceptOrder.value,
				sbo: this.reviewOrder.sbo.value,
				companyId: this.order.companyId,
				acceptedReason: this.reviewOrder.comment.value
			}
			var formData = new FormData();
			formData.append("request", JSON.stringify(request));
			formData.append("releaseLetter", this.reviewOrder.releaseLetter.value);
			formData.append("releaseSlip", this.reviewOrder.releaseSlip.value);
			exTankService.acceptOrRejectExTankOrder(formData).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						if(successResponse.data.validationResponse.valuesAreValid){
							this.successModal.modalMessage = "Order has been successfully reviewed";
							this.successModal.showModal = true;
						}
						else{
							this.reviewOrder.acceptOrder.hasError = successResponse.data.validationResponse.acceptOrRejectValidationResponse.hasError;
							this.reviewOrder.acceptOrder.errorMessage = successResponse.data.validationResponse.acceptOrRejectValidationResponse.message;
							
							this.reviewOrder.sbo.hasError = successResponse.data.validationResponse.sboValidationResponse.hasError;
							this.reviewOrder.sbo.errorMessage = successResponse.data.validationResponse.sboValidationResponse.message;
						}
						
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onSuccessModalOkClick(){
			this.successModal.showModal = false;
			this.$router.go(-1);
		},
		setBreadcrumbs() {
			var pageTitle = "Review Ex-Tank Order - #" + this.order.orderId + " (" + this.order.registeredCompanyName + ")";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
		this.orderStatus = orderHelper.orderStatus;
	},
	watch:{
		orderExTankId:{
			handler: function () {
				if (this.orderExTankId !== null && this.orderExTankId > 0) {
					this.getExTankOrder();
				}
			},
			immediate: true,
			deep: true
		}
	}
};